__turbopack_context__.v({
  "btnWrapper": "SideButtons-module-scss-module__m2EgKW__btnWrapper",
  "buttonPosition": "SideButtons-module-scss-module__m2EgKW__buttonPosition",
  "closeSpan": "SideButtons-module-scss-module__m2EgKW__closeSpan",
  "headerVideo": "SideButtons-module-scss-module__m2EgKW__headerVideo",
  "imgIconSize": "SideButtons-module-scss-module__m2EgKW__imgIconSize",
  "imgSize": "SideButtons-module-scss-module__m2EgKW__imgSize",
  "isatDesc": "SideButtons-module-scss-module__m2EgKW__isatDesc",
  "isatHead": "SideButtons-module-scss-module__m2EgKW__isatHead",
  "isatWrapper": "SideButtons-module-scss-module__m2EgKW__isatWrapper",
  "sideBtnRoot": "SideButtons-module-scss-module__m2EgKW__sideBtnRoot",
  "slot_time": "SideButtons-module-scss-module__m2EgKW__slot_time",
  "stickCTAbtn": "SideButtons-module-scss-module__m2EgKW__stickCTAbtn",
  "stickyApply": "SideButtons-module-scss-module__m2EgKW__stickyApply",
  "stickyApplyBtn": "SideButtons-module-scss-module__m2EgKW__stickyApplyBtn",
  "stickyApplymob": "SideButtons-module-scss-module__m2EgKW__stickyApplymob",
  "superscript": "SideButtons-module-scss-module__m2EgKW__superscript",
  "test_container": "SideButtons-module-scss-module__m2EgKW__test_container",
  "test_date": "SideButtons-module-scss-module__m2EgKW__test_date",
  "test_slots": "SideButtons-module-scss-module__m2EgKW__test_slots",
  "toolParaDanger": "SideButtons-module-scss-module__m2EgKW__toolParaDanger",
  "tooltipAboveButton": "SideButtons-module-scss-module__m2EgKW__tooltipAboveButton",
  "tooltipAtBottom": "SideButtons-module-scss-module__m2EgKW__tooltipAtBottom",
  "tooltipButton": "SideButtons-module-scss-module__m2EgKW__tooltipButton",
  "tooltipClose": "SideButtons-module-scss-module__m2EgKW__tooltipClose",
  "tooltipDiv": "SideButtons-module-scss-module__m2EgKW__tooltipDiv",
  "tooltipImage": "SideButtons-module-scss-module__m2EgKW__tooltipImage",
  "tooltipPara": "SideButtons-module-scss-module__m2EgKW__tooltipPara",
  "videoTooltip": "SideButtons-module-scss-module__m2EgKW__videoTooltip",
  "videoTooltipClose": "SideButtons-module-scss-module__m2EgKW__videoTooltipClose",
  "videoTooltipRightAlign": "SideButtons-module-scss-module__m2EgKW__videoTooltipRightAlign",
});
